import React from 'react';
import { Segmented, DatePicker } from 'antd';
import './ndoePeriodPicker.css';

const { RangePicker } = DatePicker;

/**
 * NdoePeriodPicker — sélecteur de période des rapports.
 *
 * Présets décisionnels 7 / 30 / 90 / 180 jours + période personnalisée.
 *
 * Props :
 *  - value    : { period: 7|30|90|180|'custom', start_date?, end_date? }
 *  - onChange : (next) => void  (même forme que `value`)
 *  - className
 */
const PRESETS = [
  { label: '7 j', value: 7 },
  { label: '30 j', value: 30 },
  { label: '90 j', value: 90 },
  { label: '180 j', value: 180 },
  { label: 'Perso', value: 'custom' },
];

export default function NdoePeriodPicker({ value = { period: 30 }, onChange, className = '' }) {
  const isCustom = value.period === 'custom';

  const handleSegment = (next) => {
    if (next === 'custom') onChange({ period: 'custom', start_date: value.start_date, end_date: value.end_date });
    else onChange({ period: next });
  };

  const handleRange = (dates) => {
    if (!dates || !dates[0] || !dates[1]) { onChange({ period: 'custom' }); return; }
    onChange({
      period: 'custom',
      start_date: dates[0].format('YYYY-MM-DD'),
      end_date: dates[1].format('YYYY-MM-DD'),
    });
  };

  return (
    <div className={`ndoe-period ${className}`}>
      <Segmented options={PRESETS} value={value.period} onChange={handleSegment} />
      {isCustom && (
        <RangePicker
          className="ndoe-period__range"
          onChange={handleRange}
          placeholder={['Depuis', "Jusqu'à"]}
          allowClear
        />
      )}
    </div>
  );
}
